import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/600.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initializeTelemetry } from "./app-insights";
import { App } from "./app.component";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

initializeTelemetry();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
